import { useContext } from "react";
import AppContext from "../../contexts/app-context";
import InvoiceView from "../instances/newExternals/InvoiceView";
import PurchaseInvoiceView from "../instances/newExternals/PurchaseInvoiceView";

export default function NumberPurchaseInvoice({
  id,
  number,
  content,
  style,
  search,
  clickable = true,
}: {
  id:number,
  number: number,
  content?: String,
  style?: React.CSSProperties,
  search?:any,
  clickable?: Boolean
}) {
  const modal:any = useContext(AppContext);

  return (
    <div
      onClick={() => {
        if (clickable) {
          modal.setModal({
            show: true,
            type: "Faktura",
            width: "superwide",
            content: (
              <PurchaseInvoiceView
                inModal={true}
                id={id}
                number={number}
                search={search}
              />
            ),
          });
        }
      }}
      className="clickable-details"
      style={{ cursor: "pointer", ...style }}
      title={String(id)}
    >
      {content ? content : <div>{number}</div>}
    </div>
  );

  /*return (
      <Link to={`../order-view?id=${data.id}`}>
        <div title={data.id}>{data.number_order.replaceAll("/", ".")}</div>
      </Link>
    );*/
}
